// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--8622f";
export var headingContainer = "index-module--heading-container--ce540";
export var highlight = "index-module--highlight--d40cc";
export var highlightLine = "index-module--highlight-line--b0fa0";
export var image1 = "index-module--image-1--87214";
export var image2 = "index-module--image-2--705de";
export var imageContainer = "index-module--image-container--cb105";